import {
  BusinessBeneficiaryListItem,
  CryptoBeneficiaryListItem,
  CustomerListItem,
  IndividualBeneficiaryListItem,
  UnknownBeneficiaryListItem,
} from '@razz-team/ui-web';
import { BeneficiaryListItem } from '../../ListItem/BeneficiaryListItem';
import { BankBeneficiaryType, TransferBeneficiary } from './types';
import { useCustomerSearchQuery } from '../../../api/customers';

export function TransferBeneficiaryListItem({
  beneficiary,
}: {
  beneficiary: TransferBeneficiary | null | undefined;
}) {
  const receiverQuery = useCustomerSearchQuery(
    beneficiary?.type === 'internal' && beneficiary.value.receiverId
      ? { type: 'id', value: beneficiary.value.receiverId }
      : undefined,
  );

  switch (beneficiary?.type) {
    case 'existing':
      return <BeneficiaryListItem beneficiary={beneficiary.value} />;
    case 'bank': {
      switch (beneficiary.valueType) {
        case BankBeneficiaryType.business:
          return (
            <BusinessBeneficiaryListItem
              currency={beneficiary.value.currency}
              displayName={beneficiary.value.displayName}
              businessName={beneficiary.value.businessName ?? ''}
              accountNumber={beneficiary.value.accountNumber}
            />
          );
        case BankBeneficiaryType.individual:
          return (
            <IndividualBeneficiaryListItem
              currency={beneficiary.value.currency}
              displayName={beneficiary.value.displayName}
              individualName={beneficiary.value.individualName ?? ''}
              accountNumber={beneficiary.value.accountNumber}
            />
          );
        default:
          return null;
      }
    }
    case 'crypto':
      return (
        <CryptoBeneficiaryListItem
          network={beneficiary.value.transferNetworkId ?? ''}
          currency={beneficiary.value.currency}
          displayName={beneficiary.value.displayName}
          accountNumber={beneficiary.value.accountNumber}
          subtype={beneficiary.value.subtype}
          beneficiaryName={beneficiary.value.beneficiaryName}
        />
      );
    case 'internal':
      return <CustomerListItem customer={receiverQuery.data} loading={receiverQuery.isPending} />;

    default:
      return <UnknownBeneficiaryListItem />;
  }
}
